import React, { useState } from 'react'

import BriefProjectSettingsDialog from '../brief-project-settings-dialog'
import DeleteProjectDialog from '../delete-project-dialog'
import RenameProjectDialog from '../rename-project-dialog'

type UseBriefProjectMenuOptions = {
  briefProjectId?: string
}

/**
 * Brief project menu state and handlers, shared by the three-dot menu
 * (BriefProjectActions) and the row's right-click menu
 * (BriefProjectContextMenu) so the two can't drift apart.
 *
 * The dialogs are returned rather than rendered by the menu items
 * themselves because the menu content unmounts on close, which would
 * otherwise close the dialog it just opened.
 */
export const useBriefProjectMenu = ({
  briefProjectId,
}: UseBriefProjectMenuOptions) => {
  const [deleteProjectDialogOpen, setDeleteProjectDialogOpen] = useState(false)
  const [renameProjectDialogOpen, setRenameProjectDialogOpen] = useState(false)
  const [settingsDialogOpen, setSettingsDialogOpen] = useState(false)

  const handleRenameProject = () => {
    setRenameProjectDialogOpen(true)
  }

  const handleOpenSettings = () => {
    setSettingsDialogOpen(true)
  }

  const handleDeleteProject = () => {
    setDeleteProjectDialogOpen(true)
  }

  const dialogs = (
    <>
      {deleteProjectDialogOpen && (
        <DeleteProjectDialog
          onOpenChange={setDeleteProjectDialogOpen}
          briefProjectId={briefProjectId}
        />
      )}
      {renameProjectDialogOpen && (
        <RenameProjectDialog
          onOpenChange={setRenameProjectDialogOpen}
          briefProjectId={briefProjectId}
        />
      )}
      {settingsDialogOpen && briefProjectId && (
        <BriefProjectSettingsDialog
          onOpenChange={setSettingsDialogOpen}
          briefProjectId={briefProjectId}
        />
      )}
    </>
  )

  return {
    handleRenameProject,
    handleOpenSettings,
    handleDeleteProject,
    dialogs,
  }
}
